import { useEffect, useState } from "react";
import api from "../../services/api";

interface TopicCounterProps {
  onUpdate?: (count: number) => void;
}

export default function TopicCounter({ onUpdate }: TopicCounterProps) {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    api.get("/topics")
      .then(res => {
        const c = Array.isArray(res.data) ? res.data.length : 0;
        setCount(c);
        if (onUpdate) onUpdate(c);
      })
      .catch(() => setCount(0));
  }, [onUpdate]);

  return (
    <div className="text-6xl font-black text-on-surface tracking-tighter">
      {count !== null ? count : "..."}
    </div>
  );
}
